import { sanitizeCube } from '.'
import { CubeTest } from '../types'

export default function (cubeTest: CubeTest) {
  const { cubeNumber, cubes, ...data } = cubeTest
  return { ...data, cubes: cubes.map(cube => sanitizeCube(cube)) }
}
